import { DarkThemeToggle } from "@/components/DarkThemeToggle/DarkThemeToggle";
import { NavLoadingIcon } from "@/components/NavLoadingIcon";

const UnAuthLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <div className="public-page relative flow-root min-h-dvh [background-color:var(--color-background-public)]">
      <header className="public-nav relative [z-index:3] [min-height:76px] [padding:16px_max(24px,_env(safe-area-inset-right))_16px_max(16px,_env(safe-area-inset-left))] flex items-center justify-between">
        <a
          href="/login"
          aria-label="Bubble home"
          className="flex items-center font-semibold"
        >
          <NavLoadingIcon />
          Bubble
        </a>
        <DarkThemeToggle />
      </header>
      {children}
    </div>
  );
};

export default UnAuthLayout;
